module.exports = __webpack_public_path__ + "static/media/race-room-rest.9e5b1f4f.png";